import { Col, DatePicker, Form, Input, InputNumber, Row, Tooltip } from 'antd'
import FormSectionTitle from 'elements/FormSectionTitle'
import withKeyValue from 'elements/HOC/WithKeyValue'
import withSort from 'elements/HOC/withSort'
import withSpinning from 'elements/HOC/withSpinning'
import useFetchSelect from 'elements/Hooks/useFetchSelect'
import CustomDebounceSelect from 'elements/Select/CustomDebounceSelect'
import CustomSelect from 'elements/Select/CustomSelect'
import OrganisationsSelect from 'elements/Select/Organistaions'
import withData from 'elements/Select/withData'
import withUrlFetch from 'elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules, threeFormItemLayout } from 'modules/FormItems'
import { dateVal, numVal, strVal } from 'modules/Utils'
import moment from 'moment'
import React, { useEffect } from 'react'
import { compose } from 'recompose'
import CustomSpin from '../../../elements/CustomSpin'
import { GlobalContext } from '../../../Global'
const { TextArea } = Input

function WarrantyForm(props) {
  const { tenantOptions, member } = React.useContext(GlobalContext)
  const { fetching, data, isNew } = props

  const { getFieldDecorator, setFieldsValue, getFieldValue } = props.form
  const isProduct = (getFieldValue('warrantyType') || get(data, 'warrantyType')) === 'Product'
  const isSales = (getFieldValue('allocation') || get(data, 'allocation')) === 'Customer'
  const isInternal = (getFieldValue('allocation') || get(data, 'allocation')) === 'Internal'
  const isAsset = (getFieldValue('allocationType') || get(data, 'allocationType')) === 'Asset'
  const isSO = (!!getFieldValue('sale.salesOrder._id') || get(!!data, 'sale.salesOrder._id'))
  const isPO = (!!getFieldValue('purchase.order._id') || get(!!data, 'purchase.order._id'))

  const POWarrantyStartDate = getFieldValue('purchase.warranty.startDate') || get(data, 'purchase.warranty.startDate')
  const POWarrantyPeriod = getFieldValue('purchase.warranty.months') || get(data, 'purchase.warranty.months') || 12
  useEffect(() => {
    if (POWarrantyStartDate && POWarrantyPeriod) {
      console.log(77, POWarrantyStartDate, POWarrantyPeriod)
      setFieldsValue({
        'purchase.warranty.endDate': moment(POWarrantyStartDate).add(POWarrantyPeriod, 'M'),
      })
    }
  }, [JSON.stringify(POWarrantyStartDate), POWarrantyPeriod])

  const SOWarrantyStartDate = getFieldValue('sale.warranty.startDate') || get(data, 'sale.warranty.startDate')
  const SOWarrantyPeriod = getFieldValue('sale.warranty.months') || get(data, 'sale.warranty.months') || 12
  useEffect(() => {
    if (SOWarrantyStartDate && SOWarrantyPeriod) {
      setFieldsValue({
        'sale.warranty.endDate': moment(SOWarrantyStartDate).add(SOWarrantyPeriod, 'M'),
      })
    }
  }, [JSON.stringify(SOWarrantyStartDate), SOWarrantyPeriod])

  const vendor = (getFieldValue('purchase.vendor._id') || '').replace('members/', '')
  const company = (getFieldValue('company._id') || '').replace('members/', '')

  const { SelectData: PurchaseOrderSelect, selected: purchase } = useFetchSelect({
    url: `orders?select=_id,code,title,date&vendor=${vendor}&company=${company}`,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
    mapFunction: (c) => ({
      ...c,
      title: `[${c.code}] ${c.title}`,
    }),
  })

  useEffect(() => {
    if (get(purchase, 'date'))
      setFieldsValue({
        'purchase.date': dateVal(purchase, 'date'),
      })
  }, [get(purchase, 'date')])

  const client = (getFieldValue('sale.customer._id') || '').replace('members/', '')
  const { SelectData: SalesOrderSelect, selected: sales } = useFetchSelect({
    url: `sales?select=_id,code,title,date&client=${client}&company=${company}&status=Approved`,
    dependencyArray: [client],
    dontFetch: isEmpty(client),
    mapFunction: (c) => ({
      ...c,
      title: `[${c.code}]  ${c.title}`,
    }),
  })

  useEffect(() => {
    if (get(sales, 'date'))
      setFieldsValue({
        'sale.date': dateVal(sales, 'date'),
      })
  }, [get(sales, 'date')])

  const { SelectData: ProductSelect } = useFetchSelect({
    url: `/products?select=_id,name,code&owner=members/${company}`,
    dependencyArray: [company],
    dontFetch: isEmpty(company),
    mapFunction: (c) => ({
      ...c,
      title: `[${c.code}]  ${c.name}`,
    }),
  })

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <Row>
          <FormSectionTitle title={'Details'} />
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Item Description">
              {getFieldDecorator('name', {
                initialValue: strVal(data, 'name'),
                rules: rules.input,
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Warranty Type">
              {getFieldDecorator('warrantyType', {
                initialValue: get(data, 'warrantyType'),
                rules: rules.select,
              })(<SelectWarrantyType />)}
            </Form.Item>
          </Col>
          {!isNew && (
            <>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Serial">
                {getFieldDecorator('_key', {
                  initialValue: strVal(data, '_key'),
                })(<Input disabled />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="QR URL">
            {getFieldDecorator('_key', {
              initialValue: strVal(data, '_key'),
            })(<span>{`https://warranty.${get(member, 'tenantGroup.baseURL')}?wid=${get(data,'_key')}`}</span>)}
              </Form.Item>
            </Col>
            </>
          )}
        </Row>
        {isProduct && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Model">
              {getFieldDecorator('model', {
                initialValue: strVal(data, 'model'),
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Identifier">
              {getFieldDecorator('oemSerial', {
                initialValue: strVal(data, 'oemSerial'),
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
        )}
        <Row>
          <Col span={24}>
            <Form.Item {...defaultFormItemLayout} label="Notes">
              {getFieldDecorator('notes', {
                initialValue: strVal(data, 'notes'),
              })(<TextArea placeholder="Notes" rows={4} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Company">
              {getFieldDecorator('company._id', {
                initialValue: get(data, 'company._id'),
                rules: rules.select,
              })(<OrganisationsSelect />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Allocation">
              {getFieldDecorator('allocation', {
                initialValue: strVal(data, 'allocation'),
                rules: rules.select,
              })(<SelectAllocation />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          {isInternal && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Allocation Type">
              {getFieldDecorator('allocationType', {
                initialValue: get(data, 'allocationType'),
                rules: rules.select,
              })(<SelectAllocationType />)}
            </Form.Item>
          </Col>
          )}

          {isAsset && (
            /*<Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Asset">
                {getFieldDecorator('asset._id', {
                  initialValue: get(data, 'asset._id'),
                  //rules: rules.select,
                })(<AssetSelect valueAtr="name" keyAtr="_id" />)}
              </Form.Item>
            </Col>*/
            '')}

          {isProduct && !isAsset && (
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Product">
                {getFieldDecorator('product._id', {
                  initialValue: get(data, 'product._id'),
                  rules: rules.select,
                })(<ProductSelect valueAtr="name" keyAtr="_id" />)}
              </Form.Item>
            </Col>
          )}
        </Row>

        <Row>
          <FormSectionTitle title={'Purchase'} />
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Vendor'}>
              {getFieldDecorator('purchase.vendor._id', {
                initialValue: strVal(data, 'purchase.vendor._id'),
                rules: rules.select,
              })(<MemberOrgSelect valueAtr="fn" keyAtr="_id" />)}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Order">
              {getFieldDecorator('purchase.order._id', {
                initialValue: get(data, 'purchase.order._id'),
                //rules: rules.select,
              })(<PurchaseOrderSelect valueAtr="title" keyAtr="_id" />)}
            </Form.Item>
          </Col>
          {isPO && (
            <>
            <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Purchase Date'}>
              {getFieldDecorator('purchase.date', {
                initialValue: dateVal(data, 'purchase.date'),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
            <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Warranty Start Date'}>
              {getFieldDecorator('purchase.warranty.startDate', {
                initialValue: dateVal(data, 'purchase.warranty.startDate'),
                //rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
            <Col span={8}>
                <Form.Item {...threeFormItemLayout} label={'Warranty Months'}>
                  {getFieldDecorator('sale.warranty.months', {
                    initialValue: numVal(data, 'sale.warranty.months') || 12,
                    //rules: rules.input,
                  })(<InputNumber style={{ width: '100%' }} />)}
                </Form.Item>
              </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Warranty End Date'}>
                {getFieldDecorator('purchase.warranty.endDate', {
                  initialValue: dateVal(data, 'purchase.warranty.endDate'),
                  //rules: rules.date,
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
          </Col>
            </>
            )}
        </Row>

        {isSales && (
          <>
            <Row>
              <FormSectionTitle title={'Sale'} />
            </Row>
            <Row>
              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label={'Customer'}>
                  {getFieldDecorator('sale.customer._id', {
                    initialValue: strVal(data, 'sale.customer._id'),
                    rules: rules.select,
                  })(<MemberSelect valueAtr="fn" keyAtr="_id" />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item {...threeFormItemLayout} label="Sales Order">
                  {getFieldDecorator('sale.salesOrder._id', {
                    initialValue: get(data, 'sale.salesOrder._id'),
                    //rules: rules.select,
                  })(<SalesOrderSelect valueAtr="title" keyAtr="_id" />)}
                </Form.Item>
              </Col>
              {isSO && (
                <>
                <Col span={8}>
                  <Form.Item {...threeFormItemLayout} label={'Sales Date'}>
                    {getFieldDecorator('sale.date', {
                      initialValue: dateVal(data, 'sale.date'),
                      rules: rules.date,
                    })(<DatePicker style={{ width: '100%' }} />)}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item {...threeFormItemLayout} label={'Warranty Start Date'}>
                    {getFieldDecorator('sale.warranty.startDate', {
                      initialValue: dateVal(data, 'sale.warranty.startDate'),
                      rules: rules.date,
                    })(<DatePicker style={{ width: '100%' }} />)}
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item {...threeFormItemLayout} label={'Warranty Months'}>
                    {getFieldDecorator('sale.warranty.months', {
                      initialValue: numVal(data, 'sale.warranty.months') || 12,
                      rules: rules.input,
                    })(<InputNumber style={{ width: '100%' }} />)}
                  </Form.Item>
                </Col>
                  <Col span={8}>
                    <Form.Item {...threeFormItemLayout} label={'Warranty End Date'}>
                      {getFieldDecorator('sale.warranty.endDate', {
                        initialValue: dateVal(data, 'sale.warranty.endDate'),
                        rules: rules.date,
                      })(<DatePicker style={{ width: '100%' }} />)}
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
          </>
        )}
      </Form>
    </CustomSpin>
  )
}

export default Form.create()(WarrantyForm)

const MemberOrgSelect = compose(
  withUrlFetch({
    name: 'members-org',
    url: `members/list/organisation?select=fn,_key,_id`,
  }),
  withSpinning
)(CustomDebounceSelect)

const MemberSelect = compose(
  withUrlFetch({
    name: 'members-org',
    url: `members/list?select=fn,_key,_id`,
  }),
  withSpinning
)(CustomDebounceSelect)

/*
const ClientSelect = compose(
  withUrlFetch({
    name: 'clients-listing',
    url: `clients?select=fn,_key,_id`,
  }),
  withSpinning
)(CustomDebounceSelect)
*/

const SelectWarrantyType = compose(
  withData({
    data: ['Product', 'Service'],
  }),
  withSort,
  withKeyValue()
)(CustomSelect)

const SelectAllocationType = compose(
  withData({
    data: ['Asset', 'Stock'],
  }),
  withSort,
  withKeyValue()
)(CustomSelect)


const SelectAllocation = compose(
  withData({
    data: ['Internal', 'Customer'],
  }),
  withSort,
  withKeyValue()
)(CustomSelect)
